import { cn } from '@/utils/tailwind';

const CallIdInput = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) => {
  return (
    <div
      className={cn(
        'inline-grid flex-shrink-0 grid-cols-1 grid-rows-1 rounded-md border border-tertiary bg-background focus-within:border-brand',
        'text-sm text-tertiary'
      )}
    >
      <input
        placeholder="Tool Call ID"
        size={12}
        className={cn(
          'col-[1] row-[1] border-none bg-transparent p-1 font-mono',
          'min-w-0 text-transparent caret-black outline-none placeholder:text-tertiary dark:caret-slate-200'
        )}
        name="value"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <div
        className={cn(
          'col-[1] row-[1] border-none bg-transparent p-1 font-mono',
          'pointer-events-none'
        )}
      >
        {value}{' '}
      </div>
    </div>
  );
};

export default CallIdInput;
